"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.actions = exports.types = void 0;
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
exports.types = {
    // TRACKING
    GET_LIST_TRACKING_BEGINS: 'GET_LIST_TRACKING_BEGINS',
    GET_LIST_TRACKING_SUCCESS: 'GET_LIST_TRACKING_SUCCESS',
    GET_LIST_TRACKING_FAILURE: 'GET_LIST_TRACKING_FAILURE',
    GET_DETAIL_TRACKING_BEGINS: 'GET_DETAIL_TRACKING_BEGINS',
    GET_DETAIL_TRACKING_SUCCESS: 'GET_DETAIL_TRACKING_SUCCESS',
    GET_DETAIL_TRACKING_FAILURE: 'GET_DETAIL_TRACKING_FAILURE',
    GET_SLOTS_TRACKING_BEGINS: 'GET_SLOTS_TRACKING_BEGINS',
    GET_SLOTS_TRACKING_SUCCESS: 'GET_SLOTS_TRACKING_SUCCESS',
    GET_SLOTS_TRACKING_FAILURE: 'GET_SLOTS_TRACKING_FAILURE',
    POST_MODIFY_APPOINTMENT_TRACKING_BEGINS: 'POST_MODIFY_APPOINTMENT_TRACKING_BEGINS',
    POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS: 'POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS',
    POST_MODIFY_APPOINTMENT_TRACKING_FAILURE: 'POST_MODIFY_APPOINTMENT_TRACKING_FAILURE',
    RESET_POST_MODIFY_APPOINTMENT_TRACKING: 'RESET_POST_MODIFY_APPOINTMENT_TRACKING',
    POST_MODIFY_PHONE_TRACKING_BEGINS: 'POST_MODIFY_PHONE_TRACKING_BEGINS',
    POST_MODIFY_PHONE_TRACKING_SUCCESS: 'POST_MODIFY_PHONE_TRACKING_SUCCESS',
    POST_MODIFY_PHONE_TRACKING_FAILURE: 'POST_MODIFY_PHONE_TRACKING_FAILURE',
    // POinfo
    GET_MY_POS_INFO: 'TRACKING/GET_MY_POS_INFO',
    GET_MY_POS_INFO_SUCCESS: 'TRACKING/GET_MY_POS_INFO_SUCCESS',
    GET_MY_POS_INFO_FAILURE: 'TRACKING/GET_MY_POS_INFO_FAILURE',
    // Celeris
    GET_CELERIS_INFO: 'TRACKING/GET_CELERIS_INFO',
    GET_CELERIS_INFO_SUCCESS: 'TRACKING/GET_CELERIS_INFO_SUCCESS',
    GET_CELERIS_INFO_FAILURE: 'TRACKING/GET_CELERIS_INFO_FAILURE',
    //orderDetails
    ORDER_DETAILS_TRACKING_BEGINS: 'ORDER_DETAILS_TRACKING_BEGINS',
    ORDER_DETAILS_TRACKING_SUCCESS: 'ORDER_DETAILS_TRACKING_SUCCESS',
    ORDER_DETAILS_TRACKING_FAILURE: 'ORDER_DETAILS_TRACKING_FAILURE',
};
exports.actions = {
    // Actions for tracking
    getListTracking: (pageNumber, update) => ({
        type: exports.types.GET_LIST_TRACKING_BEGINS,
        pageNumber,
        update,
    }),
    successGetListTracking: (data) => ({
        type: exports.types.GET_LIST_TRACKING_SUCCESS,
        payload: data,
    }),
    failureGetListTracking: (error) => ({
        type: exports.types.GET_LIST_TRACKING_FAILURE,
        payload: error,
    }),
    getDetailTracking: (data) => (Object.assign({ type: exports.types.GET_DETAIL_TRACKING_BEGINS }, data)),
    successGetDetailTracking: (data) => ({
        type: exports.types.GET_DETAIL_TRACKING_SUCCESS,
        payload: data,
    }),
    failureGetDetailTracking: (error) => ({
        type: exports.types.GET_DETAIL_TRACKING_FAILURE,
        payload: error,
    }),
    getSlotsTracking: (data) => (Object.assign({ type: exports.types.GET_SLOTS_TRACKING_BEGINS }, data)),
    successGetSlotsTracking: (data) => ({
        type: exports.types.GET_SLOTS_TRACKING_SUCCESS,
        payload: data,
    }),
    failureGetSlotsTracking: (error) => ({
        type: exports.types.GET_SLOTS_TRACKING_FAILURE,
        payload: error,
    }),
    postModifyAppointment: (params) => ({
        type: exports.types.POST_MODIFY_APPOINTMENT_TRACKING_BEGINS,
        payload: params,
    }),
    successPostModifyAppointment: (data) => ({
        type: exports.types.POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS,
        payload: data,
    }),
    failurePostModifyAppointment: (error) => ({
        type: exports.types.POST_MODIFY_APPOINTMENT_TRACKING_FAILURE,
        payload: error,
    }),
    resetPostModifyAppointment: () => ({
        type: exports.types.RESET_POST_MODIFY_APPOINTMENT_TRACKING,
    }),
    postModifyPhone: (params) => ({
        type: exports.types.POST_MODIFY_PHONE_TRACKING_BEGINS,
        payload: params,
    }),
    successPostModifyPhone: (data) => ({
        type: exports.types.POST_MODIFY_PHONE_TRACKING_SUCCESS,
        payload: data,
    }),
    failurePostModifyPhone: (error) => ({
        type: exports.types.POST_MODIFY_PHONE_TRACKING_FAILURE,
        payload: error,
    }),
    // PRODUCTINFO
    getTelcoInfoFromArrayPO: (arrayProductOffering) => ({
        type: exports.types.GET_MY_POS_INFO,
        arrayProductOffering,
    }),
    failuredGetTelcoInfoArrayFromPO: () => ({
        type: exports.types.GET_MY_POS_INFO_ERROR,
    }),
    successGetTelcoInfoArrayFromPO: (data) => ({
        type: exports.types.GET_MY_POS_INFO_SUCCESS,
        payload: data,
    }),
    getCelerisInfo: (co, sho) => ({ type: exports.types.GET_CELERIS_INFO, co, sho }),
    getCelerisInfoSuccess: (data) => ({
        type: exports.types.GET_CELERIS_INFO_SUCCESS,
        payload: data,
    }),
    getCelerisInfoFailure: () => ({ type: exports.types.GET_CELERIS_INFO_FAILURE }),
    // OrderDetails
    getOrderDetails: (params) => ({
        type: exports.types.ORDER_DETAILS_TRACKING_BEGINS,
        payload: params,
    }),
    successOrderDetails: (data) => ({
        type: exports.types.ORDER_DETAILS_TRACKING_SUCCESS,
        payload: data
    }),
    failureOrderDetails: (error) => ({
        type: exports.types.ORDER_DETAILS_TRACKING_FAILURE,
        payload: error,
    }),
};
exports.initialState = {
    // TRACKING
    listTracking: null,
    moreElements: false,
    pageNumber: 1,
    listTrackingError: null,
    listTrackingFetching: false,
    detailTracking: null,
    detailTrackingError: null,
    detailTrackingFetching: false,
    slotsTracking: null,
    slotsTrackingError: null,
    slotsTrackingFetching: true,
    modifyAppointment: null,
    modifyAppointmentFetching: false,
    modifyAppointmentError: null,
    modifyPhone: null,
    modifyPhoneFetching: false,
    modifyPhoneError: null,
    // MASSIVE POInfo
    POInfoFetching: false,
    POInfoInfoFetched: false,
    POInfoInfoError: false,
    // Celeris
    celerisInfo: null,
    celerisInfoFetching: false,
    celerisInfoError: false,
    // orderDetails
    orderDetails: null,
    orderDetailsFetching: false,
    orderDetailsError: null,
};
function reducer(state = Object.assign({}, exports.initialState), { type, payload }) {
    switch (type) {
        case HYDRATE: {
            const { tracking } = payload;
            return Object.assign(Object.assign({}, state), tracking);
        }
        case exports.types.GET_LIST_TRACKING_BEGINS:
            return Object.assign(Object.assign({}, state), { listTrackingError: null, listTrackingFetching: true });
        case exports.types.GET_LIST_TRACKING_SUCCESS: {
            const { orders, moreElements, pageNumber } = payload;
            let pageNumberToState = state.pageNumber;
            let listTrackingToShow = [...orders];
            if (pageNumber > pageNumberToState) {
                listTrackingToShow = [...state.listTracking, ...orders];
                pageNumberToState = pageNumber;
            }
            return Object.assign(Object.assign({}, state), { listTrackingError: false, listTrackingFetching: false, listTracking: [...listTrackingToShow], moreElements, pageNumber: pageNumberToState });
        }
        case exports.types.GET_LIST_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { listTracking: null, listTrackingError: true, listTrackingFetching: false });
        case exports.types.GET_DETAIL_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { detailTracking: null, detailTrackingError: true, detailTrackingFetching: false });
        case exports.types.GET_DETAIL_TRACKING_BEGINS:
            return Object.assign(Object.assign({}, state), { detailTrackingError: null, detailTrackingFetching: true });
        case exports.types.GET_DETAIL_TRACKING_SUCCESS: {
            const newTrackingDetails = payload;
            const { code } = newTrackingDetails;
            const newTrackingDetailsStructure = Object.assign({}, state.detailTracking);
            newTrackingDetailsStructure[code] = newTrackingDetails;
            return Object.assign(Object.assign({}, state), { detailTrackingError: false, detailTrackingFetching: false, detailTracking: newTrackingDetailsStructure });
        }
        case exports.types.GET_SLOTS_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { slotsTracking: null, slotsTrackingError: true, slotsTrackingFetching: false });
        case exports.types.GET_SLOTS_TRACKING_BEGINS:
            return Object.assign(Object.assign({}, state), { slotsTrackingError: null, slotsTrackingFetching: true });
        case exports.types.GET_SLOTS_TRACKING_SUCCESS: {
            const newTrackingSlots = payload;
            return Object.assign(Object.assign({}, state), { slotsTrackingError: false, slotsTrackingFetching: false, slotsTracking: newTrackingSlots });
        }
        case exports.types.POST_MODIFY_APPOINTMENT_TRACKING_BEGINS:
            return Object.assign(Object.assign({}, state), { modifyAppointment: null, modifyAppointmentFetching: true, modifyAppointmentError: false });
        case exports.types.POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS:
            return Object.assign(Object.assign({}, state), { modifyAppointment: payload, modifyAppointmentFetching: false, modifyAppointmentError: false });
        case exports.types.POST_MODIFY_APPOINTMENT_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { modifyAppointment: null, modifyAppointmentFetching: false, modifyAppointmentError: true });
        case exports.types.RESET_POST_MODIFY_APPOINTMENT_TRACKING:
            return Object.assign(Object.assign({}, state), { modifyAppointment: null, modifyAppointmentFetching: false, modifyAppointmentError: false });
        case exports.types.POST_MODIFY_PHONE_TRACKING_BEGINS:
            return Object.assign(Object.assign({}, state), { modifyPhone: null, modifyPhoneFetching: true, modifyPhoneError: false });
        case exports.types.POST_MODIFY_PHONE_TRACKING_SUCCESS:
            return Object.assign(Object.assign({}, state), { modifyPhone: payload, modifyPhoneFetching: false, modifyPhoneError: false });
        case exports.types.POST_MODIFY_PHONE_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { modifyPhone: null, modifyPhoneFetching: false, modifyPhoneError: true });
        // ALL PRODUCT INFO
        case exports.types.GET_MY_POS_INFO:
            return Object.assign(Object.assign({}, state), { POInfoFetching: true, POInfoError: false });
        case exports.types.GET_MY_POS_INFO_ERROR:
            return Object.assign(Object.assign({}, state), { POInfoFetching: false, POInfoError: true });
        case exports.types.GET_MY_POS_INFO_SUCCESS: {
            return Object.assign(Object.assign({}, state), { POInfo: payload, POInfoFetching: false, POInfoError: false });
        }
        case exports.types.GET_CELERIS_INFO: {
            return Object.assign(Object.assign({}, state), { celerisInfoFetching: true });
        }
        case exports.types.GET_CELERIS_INFO_SUCCESS: {
            const celerisInfo = payload;
            const lastDataCelerisInfo = Object.assign({}, state.celerisInfo);
            const lastKeys = Object.keys(lastDataCelerisInfo);
            if (celerisInfo && celerisInfo.sho) {
                const exist = lastKeys.find((elem) => elem === celerisInfo.sho);
                if (!exist) {
                    lastDataCelerisInfo[celerisInfo.sho] = payload;
                }
            }
            else if (celerisInfo && celerisInfo.co) {
                const exist = lastKeys.find((elem) => elem === celerisInfo.co);
                if (!exist) {
                    lastDataCelerisInfo[celerisInfo.co] = payload;
                }
            }
            return Object.assign(Object.assign({}, state), { celerisInfo: lastDataCelerisInfo, celerisInfoFetching: false, celerisInfoError: false });
        }
        case exports.types.GET_CELERIS_INFO_FAILURE: {
            return Object.assign(Object.assign({}, state), { celerisInfoFetching: false, celerisInfoError: true });
        }
        // orderDetails
        case exports.types.ORDER_DETAILS_TRACKING_BEGINS:
            return Object.assign(Object.assign({}, state), { orderDetails: null, orderDetailsFetching: true });
        case exports.types.ORDER_DETAILS_TRACKING_SUCCESS: {
            const newOrderDetailsTracking = payload;
            return Object.assign(Object.assign({}, state), { orderDetailsError: false, orderDetailsFetching: false, orderDetails: newOrderDetailsTracking });
        }
        case exports.types.ORDER_DETAILS_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { orderDetails: null, orderDetailsError: true, orderDetailsFetching: false });
        default:
            return state;
    }
}
exports.default = reducer;
//# sourceMappingURL=index.js.map